import { EBureauType } from '../../../interfaces';

export interface IFicoDetails {
  ficoDetails: IFicoDetail[];
}
export interface IFicoDetail {
  name: string;
  scoreType: string;
  score: string;
}

export interface IPersonalInformation {
  personalInformation: IPersonalInfo;
}
export interface IPersonalInfo {
  name: string;
  addresses: IAddress[];
  ssn: string;
  dataOfBirth: string;
  aka: string[];
}
export interface IAddress {
  address: string;
  reportedDate: string;
  reportedDateMessage: string;
}
export interface IEmploymentInfo {
  employmentInfo: IEmploymentData[];
}

export interface IEmploymentData {
  companyName: string;
  employerAddress: string;
  origination: string;
  dateReported: string;
  dateSeparated: string;
  income: string;
  jobTitle: string;
}
export interface ILoan {
  loan: ILoanData[];
}
export interface ILoanData {
  creditorName: string;
  originalAmount: string;
  term: string;
  balance: string;
  payment: string;
  monthsRemaining: string;
  status: string;
  estApr: string;
  coSigner: string;
}

export interface IInquiries {
  inquiries: IInquiry[];
}

export interface IInquiry {
  date: string;
  subscriberName: string;
  subscriberNumber: string;
  amount: string;
  inquiryType: string;
  kob: string;
  submarket: string;
  market: string;
}

export interface ITradeLines {
  tradeLines: ITradeLine[];
  bureauType: EBureauType;
}

export interface ITradeLine {
  firmName: string;
  firmID: string;
  accountNumber: string;
  kob: string;
  tradeType: string;
  status: string;
  dateOpened: string;
  dateReported: string;
  accountType: string;
  creditLimit: string;
  highCredit: string;
  chargeOff: string;
  dateLastPayment: string;
  balance: string;
  pastDue: string;
  originalLoanValue: string;
  closedIndicator: string;
  monthlyPayment: string;
  monthlyRepayment: string;
  dateClosed: string;
  owner: string;
  past30Days: string;
  past60Days: string;
  past90Days: string;
  paymentPattern: string;
  terms: string;
  recordCode: string;
  dateLastActivity: string;
  phone: string;
  narativeDescription: string;
}
export interface IScoreCards {
  scoreCards: IScoreCard[];
}
export interface IScoreCard {
  scoreCard: string;
  scoreType: string;
  score: string;
  scoreCardReasons: IScore[];
}
interface IScore {
  code: string;
  codeReason: string;
}
export interface IEmploymentInformation {
  companyName: string;
  employerAddress: string;
  origination: string;
  dateReported: string;
  dateSeparated: string;
  income: string;
  jobTitle: string;
}
interface autoSummaryProfile {
  totOpenLoanLeaseBal: string;
  totOpenLoanLeaseMonthlyPaymentAmount: string;
  totNumLoansLeases: string;
  totNumOpenLoansLeases: string;
  totNum30DayDelLoansLeases: string;
  totNum60DayDelLoansLeases: string;
  totNum90DayDelLoansLeases: string;
  worstDelLoansLeases: string;
  worstDelDateLoansLeases: string;
  autoSummaryProfileDetails: ILoan[];
}
interface studentLoanSummaryProfileDetails {
  creditorName: string;
  originalAmount: string;
  term: string;
  balance: string;
  payment: string;
  monthsRemaining: string;
  status: string;
  estApr: string;
  coSigner: string;
}
export interface profileReportSummary {
  totalTrades: string;
  currentTrades: string;
  unratedTrades: string;
  currNegTrades: string;
  histNegTrades: string;
  numberAcctsPaid: string;
  satisfactoryAccounts: string;
  amountPastDue: string;
  days30: string;
  days60: string;
  days90: string;
  inquiriesCount: string;
  inquiriesInLast6Month: string;
  publicRecords: string;
  collections: string;
  oldestTradeDate: string;
  accountsBalance: string;
  monthlyPayment: string;
  creditLimit: string;
  highBalance: string;
  totalRealEstBalance: string;
  totalRevBalance: string;
  totInstalmentBalance: string;
  totAutoBalance: string;
  availablePercent: string;
  totalRepossessions: string;
  lastRepossessonDate: string;
  openNoLates12Month: string;
  openSatisfactory: string;
  closedSatisfactory: string;
  openAuto: string;
  autoDerogatory: string;
  lastBankruptcieDate: string;
  bankruptcies: string;
  currentPastDue: string;
}
export interface ICreditReport {
  ficoDetails: IFicoDetail[];
  mlaInformation: string;
  dateReported: string;
  personalInformation: IPersonalInfo;
  employmentInformation: IEmploymentInformation[];
  autoSummaryProfile: autoSummaryProfile;
  studentLoanSummaryProfile: {
    studentLoanSummaryProfileDetails: studentLoanSummaryProfileDetails[];
  };
  profileReportSummary: profileReportSummary;
  scoreCards: IScoreCard[];
  creditReportMessages: ICreditReportMessage[];
  publicRecords: IPublicRecords[];
  tradeLines: ITradeLine[];
  inquiries: IInquiry[];
  warningMessage: {
    messages: [string];
  };
  contactId: string;
  bureauType: EBureauType;
  fullName: string;
  creditReportPullRequired: boolean;
  collections: ICollections[];
}

export interface ICollections {
  memberNumber: string;
  creditor: string;
  status: string;
  comment: string;
  industryCode: string;
  accountNumber: string;
  dateReported: string;
  balanceDate: string;
  dateClosed: string;
  amount: string;
  balance: string;
  narrative: string | null;
}

export interface ICollectionsProps {
  collections: ICollections[];
}

export interface IPublicRecords {
  courtType: string;
  statusDate: string;
  originalDate: string;
  evaluation: string;
  amount: string;
  assetAmount: string;
  liabilityAmount: string;
  consumerComment: string;
  court: string;
  courtCode: string;
  referenceNumber: string;
  docket: string;
  recordType: string;
  disputeFlag: string;
  platiffName: string;
  accDesignator: string;
}

export interface IPublicRecordsProps {
  publicRecords: IPublicRecords[];
}

export interface ICreditReportMessage {
  reportedDate: string;
  message: string;
}

export interface ICreditReportMessageProps {
  creditReportMessages: ICreditReportMessage[];
}

export const FieldType = {
  currency: 'currency',
};

export interface IReportSummary {
  summary: profileReportSummary;
}

interface TradeSummary {
  type?: string;
  value: string;
}

export interface ICreateTradeSummary {
  [key: string]: TradeSummary;
}

export enum EBureauTypeString {
  Equifax = 'Equifax',
  Transunion = 'Transunion',
  Experian = 'Experian',
  ExperianFico = 'ExperianFico',
}

export interface ICreditScoreResponse {
  bureauType?: EBureauTypeString;
  fico?: string;
  dti?: number;
  totalIncome?: number;
  totalExpense?: number;
  creditReportTotalDebt?: number;
  name?: string;
  scoreType?: string;
  isHtmlReport: boolean;
  ficoDetails: IFicoDetail[];
}